//import { manuscript as dotmotifManuscript } from "@/papers/dotmotif/manuscript.js"
// import segmentations from '@/assets/segmentations.png';
// import dataloader from '@/assets/dataloader.png';
// import MTNeuro from '@/assets/MTNeuro_Benchmark.png'; 
// import prasad from '@/assets/prasad.png'; 
// import membranes from '@/assets/membranes.png';
// import membrane_segmentation from '@/assets/membrane_segmentation.png';
// import synapses from '@/assets/synapses.png';
// import synapse_segmentation from '@/assets/synapse_segmentation.png';

// Add the import for the base URL
import { ASSETS_BASE_URL } from '@/assets.js';

// Use the base URL to construct the full URLs to the images
const segmentationsUrl = ASSETS_BASE_URL + 'tools/segmentations.png';
const dataloaderUrl = ASSETS_BASE_URL + 'tools/dataloader.png';
const MTNeuroUrl = ASSETS_BASE_URL + 'tools/MTNeuro_Benchmark.png';
const prasadUrl = ASSETS_BASE_URL + 'tools/prasad.png';
const membranesUrl = ASSETS_BASE_URL + 'tools/membranes.png';
const membraneSegmentationUrl = ASSETS_BASE_URL + 'tools/membrane_segmentation.png';
const synapsesUrl = ASSETS_BASE_URL + 'tools/synapses.png';
const synapseSegmentationUrl = ASSETS_BASE_URL + 'tools/synapse_segmentation.png';
const aplLogo = ASSETS_BASE_URL + 'apl_logos_all_formats/apl_logo.png';
const gtLogo = ASSETS_BASE_URL + 'apl_logos_all_formats/GT.png';
const texasLogo = ASSETS_BASE_URL + 'apl_logos_all_formats/Texas.png';
const harvardLogo = ASSETS_BASE_URL + 'apl_logos_all_formats/harvard.png';
const Cites = {
    SUBSTRATE: `
    @article{Matelsky_2020_substrate,
        title={A substrate for modular, extensible data-visualization},
        volume={5}, ISSN={2058-6345},
        url={http://dx.doi.org/10.1186/s41044-019-0043-6},
        DOI={10.1186/s41044-019-0043-6},
        number={1}, journal={Big Data Analytics},
        publisher={Springer Science and Business Media LLC},
        author={Matelsky, Jordan K. and Downs, Joseph and Cowley, Hannah P. and Wester, Brock and Gray-Roncal, William},
        year={2020}, month={Feb}
    }`,
    DOTMOTIF: `
    # https://doi.org/10.1038/s41598-021-91025-5
    @article{Matelsky_Motifs_2021,
        title={{DotMotif: an open-source tool for connectome subgraph isomorphism search and graph queries}},
        volume={11},
        ISSN={2045-2322},
        url={http://dx.doi.org/10.1038/s41598-021-91025-5},
        DOI={10.1038/s41598-021-91025-5},
        number={1},
        journal={Scientific Reports},
        publisher={Springer Science and Business Media LLC},
        author={Matelsky, Jordan K. and Reilly, Elizabeth P. and Johnson, Erik C. and Stiso, Jennifer and Bassett, Danielle S. and Wester, Brock A. and Gray-Roncal, William},
        year={2021},
        month={Jun}
    }

    `
}

const intern = {
    "name": "intern",
    "link": "/tools/intern",
    "blurb": "A Python library for data access from BossDB, DVID, CloudVolume, and more.",
    "description": [
        "This library is open-source [on GitHub](https://github.com/jhuapl-boss/intern).",
        "**Installation**",
        "You can install intern from PyPI with `pip3 install intern`.",
        "",
        "**Getting Started**",
        "See the [wiki](https://github.com/jhuapl-boss/intern/wiki) for more details."
    ],
    cite: `@article{matelsky_2020_intern,
    author={Matelsky, Jordan K and Rodriguez, Luis M and Xenes, Daniel and Gion, Timothy and Hider, Robert and Wester, Brock A and Gray-Roncal, William},
    booktitle={2021 43rd Annual International Conference of the IEEE Engineering in Medicine & Biology Society (EMBC)},
    title={An Integrated Toolkit for Extensible and Reproducible Neuroscience},
    year={2021},
    volume={},
    number={},
    pages={2413-2418},
    doi={10.1109/EMBC46164.2021.9630199}
}
    `,
    pub_link: 'https://ieeexplore.ieee.org/document/9630199'
};

const dotmotif = {
    "name": "DotMotif",
    "link": "https://github.com/aplbrain/dotmotif",
    "blurb": "Subgraph isomorphisms on connectomes.",
    "description": ["This library is open-source [on GitHub](https://github.com/aplbrain/dotmotif).",
        "**Installation**",
        "You can install DotMotif with `pip install dotmotif` or from [GitHub](https://github.com/aplbrain/dotmotif/wiki/Installing).",
        "",
        "**Getting Started**",
        `
The easiest way to start using DotMotif is to import an existing NetworkX graph:

~~~python
from dotmotif import Motif, GrandIsoExecutor

# my_graph is a nx.DiGraph
E = GrandIsoExecutor(graph=my_graph)

motif = Motif("""
A -> B
B -> C
C -> A
")

# Get the number of triangles in this graph
results = E.count(motif)
~~~

A full tutorial is available [here](https://github.com/aplbrain/dotmotif/wiki/Getting-Started).

        `
    ],
    //"manuscript": [
    //    ...dotmotifManuscript
    //],
    "cite": Cites.DOTMOTIF,
    pub_link: 'https://doi.org/10.1038/s41598-021-91025-5'
};

const grandiso = {
    "name": "GrandIso",
    "link": "https://github.com/aplbrain/grandiso-networkx",
    "blurb": "Pure-python, very efficient subgraph isomorphism/monomorphism (motif-search)",
    "cite": Cites.DOTMOTIF,
    pub_link: 'https://doi.org/10.1038/s41598-021-91025-5'
}

const motifstudio = {
    "name": "Motif Studio",
    // "link": "/tools/MotifStudio",
    "link": "https://motifstudio.bossdb.org",
    "blurb": "Query large-scale connectomes using the DotMotif query syntax.",
    "cite": Cites.DOTMOTIF,
    pub_link: 'https://doi.org/10.1038/s41598-021-91025-5', 
}

const grand = {
    "name": "Grand",
    "link": "https://github.com/aplbrain/grand",
    "blurb": "Drop-in scalable graph toolkit (Dask for NetworkX)",
    "description": ["This library is open-source [on GitHub](https://github.com/aplbrain/grand).",
        "**Installation**",
        "You can install Grand with `pip install grand-graph`.",
        "**Getting Started**",

        `

_Grand_ is a Rosetta Stone of graph technologies.

**Example use-cases**

-   True-serverless graph databases using DynamoDB
-   Query a host graph in SQL for subgraph isomorphisms with DotMotif

**Why it's a big deal**

_Grand_ is a Rosetta Stone of graph technologies. In short, a _Grand_ graph has a "Backend," which handles the nitty-gritty of talking to data on disk (or in the cloud), and an "Dialect", which is your preferred way of talking to a graph.

For example, here's how you make a graph that is persisted in DynamoDB (the "Backend") but that you can talk to as though it's a networkx.DiGraph (the "Dialect"):

~~~python
import grand

G = grand.Graph(backend=grand.DynamoDBBackend())

G.nx.add_node("Jordan", type="Person")
G.nx.add_node("DotMotif", type="Project")

G.nx.add_edge("Jordan", "DotMotif", type="Created")

assert len(G.nx.edges()) == 1
assert len(G.nx.nodes()) == 2
~~~

It doesn't stop there. If you like the way IGraph handles anonymous node insertion (ugh) but you want to handle the graph using regular NetworkX syntax, use a IGraphDialect and then switch to a NetworkXDialect halfway through:

~~~python
import grand

G = grand.Graph()

# Start in igraph:
G.igraph.add_vertices(5)

# A little bit of networkit:
G.networkit.addNode()

# And switch to networkx:
assert len(G.nx.nodes()) == 6

# And back to igraph!
assert len(G.igraph.vs) == 6
~~~

You should be able to use the "dialect" objects the same way you'd use a real graph from the constituent libraries. For example, here is a NetworkX algorithm running on NetworkX graphs alongside Grand graphs:

~~~python
import networkx as nx

nx.algorithms.isomorphism.GraphMatcher(networkxGraph, grandGraph.nx)
~~~

You can read more about usage and learn about backends and dialects in [the wiki](https://github.com/aplbrain/grand/wiki).

    `],
    "cite": Cites.DOTMOTIF,
    pub_link: 'https://doi.org/10.1038/s41598-021-91025-5'
}

const bossphorus = {
    "name": "bossphorus",
    "link": "https://github.com/aplbrain/bossphorus",
    "blurb": "A simple volumetric datastore modeled after the BossDB API.",
};

const npyjs = {
    "name": "npyjs",
    "link": "https://github.com/aplbrain/npyjs",
    "blurb": "Read numpy .npy files in JavaScript/Node.js.",
};

const prDownload = {
    "name": "BossDB Labs: PyReconstruct",
    "link": "https://pyreconstruct-download.labs.bossdb.org",
    "blurb": "Use this site to download a subvolume compatible with PyReconstruct.",
    "attribution_logos": [aplLogo, texasLogo],
};

const neuroglancerUrlShortener = {
    "name": "Neuroglancer URL Shortener",
    "link": "https://shorten.bossdb.io/",
    "blurb": "Create short, shareable links for Neuroglancer views.",
};

const substrate = {
    "name": "substrate",
    "link": "https://github.com/aplbrain/substrate",
    "blurb": "A high-speed three.js substrate for visualizing biofidelic data.",
    "description": [
        "Substrate is a JavaScript library for 3D visualization in the browser.",
        "This library is open-source [on GitHub](https://github.com/aplbrain/substrate).",
        "**Installation**",
        "You can install substrate via npm or yarn `npm install apl-substrate`.",
        "",
        "**Getting Started**",
        "See the [GitHub page](https://github.com/aplbrain/substrate) for more details."
    ],
    "cite": Cites.SUBSTRATE,
    pub_link: 'http://dx.doi.org/10.1186/s41044-019-0043-6'
}

const pytri = {
    "name": "pytri",
    "link": "https://github.com/aplbrain/pytri",
    "blurb": "A Python library for visualizing 3D data in a Jupyter Notebook.",
    "description": [
        "Pytri is a Jupyter Notebook tool that leverages [substrate](/tools/substrate) for 3D data visualization and overlays.",
        "This library is open-source [on GitHub](https://github.com/aplbrain/pytri).",
        "**Installation**",
        "You can install pytri with `pip install pytri`.",
        "",
        "**Getting Started**",
        "To get started using pytri, see [the pytri documentation](https://aplbrain.github.io/pytri/).",
    ],
    "cite": Cites.SUBSTRATE,
    pub_link: 'http://dx.doi.org/10.1186/s41044-019-0043-6'
}

const colocar = {
    "name": "colocar",
    "link": "https://github.com/aplbrain/colocar",
    "blurb": "Tools for sparse human annotation of three-dimensional [neuroscience] datasets."
}
const mesh_deco = {
    "name": "mesh-deco",
    "link": "https://github.com/aplbrain/mesh-deco",
    "blurb": "A Python-based utility for distributed meshing."
}

const saber = {
    "name": "SABER",
    "link": "https://github.com/aplbrain/saber",
    "blurb": "Library of containerized tools and a workflow deployment system."
}

const reconstruct2stack = {
    "name": "reconstruct2stack",
    "link": "https://github.com/aplbrain/reconstruct2stack",
    "blurb": "Python-based utility to convert RECONSTRUCT stacks to numpy array or image files."
}

const neuvue = {
    "name": "NeuVue",
    //This should be changed because of the tools format, the error stems from "link": "https://app.neuvue.io/" as opposed to the tools link
    "link": "/tools/Neuvue",
    "blurb": "Software platform for large-scale proofreading of machine segmentation and neural circuit reconstruction in high-resolution electron microscopy connectomics datasets.",
    "description": [
        "**About**",
        "NeuVue is a software platform created for large-scale proofreading of machine segmentation and neural circuit reconstruction in high-resolution electron microscopy connectomics datasets. NeuVue provides an intuitive interface for proofreaders to collaboratively view, annotate, and edit segmentation and connectivity data. NeuVue has everything you need for a high-throughput proofreading workflow! Analytical dashboards, data visualization tools, and simple API enables stakeholders real-time access to proofreading progress at an individual proofreader level as well as global reconstruction quality insights. NeuVue is intentionally agnostic to the underlying data management backend and can be easily deployed in an AWS environment. Proofreaders can work with powerful streamlined tools for splitting and merging connectivity data in dense nano-scale reconstruction better than ever before.",
        "Check out NeuVue here: https://app.neuvue.io/",
    ],
    cite: `@article {Xenes2022.07.18.500521,
        author = {Xenes, Daniel and Kitchell, Lindsey M. and Rivlin, Patricia K. and Brodsky, Rachel and Gooden, Hannah and Joyce, Justin and Luna, Diego and Norman-Tenazas, Raphael and Ramsden, Devin and Romero, Kevin and Rose, Victoria and Villafane-Delgado, Marisel and Gray-Roncal, William and Wester, Brock},
        title = {NeuVue: A Framework and Workflows for High-Throughput Electron Microscopy Connectomics Proofreading},
        elocation-id = {2022.07.18.500521},
        year = {2022},
        doi = {10.1101/2022.07.18.500521},
        URL = {https://www.biorxiv.org/content/early/2022/07/20/2022.07.18.500521},
        eprint = {https://www.biorxiv.org/content/early/2022/07/20/2022.07.18.500521.full.pdf},
        journal = {bioRxiv}
    }    
    `,
    pub_link: 'https://doi.org/10.1101/2022.07.18.500521'  
}

const neuprint = {
    "name": "NeuPrint",
    "link": "/tools/NeuPrint",
    "blurb": "Analyze and explore connectome data stored in Neo4j using the neuPrint ecosystem.",
    "description": [
        "**About**",
        "neuPrint is a set of tools for loading and analyzing connectome data into a Neo4j database, originally written by the [FlyEM team](https://www.janelia.org/project-team/flyem) at Janelia Research Campus. ",
        "This library is open-source [on GitHub](https://github.com/aplbrain/neuPrint).",
        "**Getting Started**",
        "To get started using neuPrint, visit [https://neuprint.bossdb.io/](https://neuprint.bossdb.io/) to access datasets in the browser or download [this notebook](https://github.com/aplbrain/bossdb_cookbook/blob/main/notebooks/Querying-Connectomes-With-NeuPrint.ipynb) to access datasets using Python.",
        "**Learn More**",
        "Read more about neuPrint in the [paper](https://doi.org/10.3389/fninf.2022.896292)."
    ],
    "cite": `
@article{10.3389/fninf.2022.896292,
    title={neuPrint: An open access tool for EM connectomics},
    volume={16},
    ISSN={1662-5196}}
    url={https://www.frontiersin.org/articles/10.3389/fninf.2022.896292},
    DOI={10.3389/fninf.2022.896292},
    journal={Frontiers in Neuroinformatics},
    author={Plaza, Stephen M. and Clements, Jody and Dolafi, Tom and Umayam, Lowell and Neubarth, Nicole N. and Scheffer, Louis K. and Berg, Stuart},
    year={2022}
}`,
    pub_link: "https://doi.org/10.3389/fninf.2022.896292"
}

const queries = {
    "name": "Query Engine",
    "link": "/tools/Query%20Engine",
    "blurb": "Personalized query platform for analyzing and contributing to connectomic dataset growth",
    "attribution_logos": [aplLogo, harvardLogo],
    "description": [
        "**Getting Started**",
        "To get started using the Query Engine, visit [https://queries.bossdb.org/](https://queries.bossdb.org/).",
        "**Learn More**",
        "You can read more about the queries tool in the [paper](https://doi.org/10.3389/fninf.2022.828458)"
    ],
    "cite": `
@article{10.3389/fninf.2022.828458,
	title={Connectomics {Annotation} {Metadata} {Standardization} for {Increased} {Accessibility} and {Queryability}},
	volume={16},
	ISSN={1662-5196},
	url={https://www.frontiersin.org/articles/10.3389/fninf.2022.828458},
	DOI={10.3389/fninf.2022.828458}
	journal={Frontiers in Neuroinformatics},
	author={Sanchez, Morgan and Moore, Dymon and Johnson, Erik C. and Wester, Brock and Lichtman, Jeff W. and Gray-Roncal, William},
	year={2022},
}`,
    pub_link: "https://doi.org/10.3389/fninf.2022.828458"

}

const kasthuriChallenge = {
    "name": "Kasthuri Challenge",
    "link": "/tools/kasthuri-challenge",
    "blurb": "Generate annotations for a sub-volume of mouse neocortex imaged with a scanning electron microscope.", 
    "description": [
        "Follow the instructions provided here at our [GitHub Repository](https://github.com/aplbrain/bossdb-kasthuri-challenge).",
        '<img src="' + dataloaderUrl + '" alt="dataloader" style="width:100%;">',
        "**Description**",
        "Train deep learning segmentation models to accurately detect synapses and membranes.",
        '<img src="' + segmentationsUrl + '" alt="segmentations">', 
    ],
    "cite": `
    @article{kasthuri_2015,
        doi = {10.1016/j.cell.2015.06.054},
        url = {https://www.cell.com/cell/fulltext/S0092-8674(15)00824-7},
        year = 2015,
        month = {jul},
        publisher = {Cell},
        author = {Kasthuri, N and Hayworth, KJ and Berger, DR and Schalek, RL and Conchello, JA and Knowles-Barley, S and Lee, D and Vázquez-Reina, A and Kaynig, V and Jones, TR and Roberts, M and Morgan, JL and Tapia, JC and Seung, HS and Roncal, WG and Vogelstein, JT and Burns, R and Sussman, DL and Priebe, CE and Pfister, H and Lichtman, JW},
        title = {Saturated Reconstruction of a Volume of Neocortex},
        journal = {Cell},
        volume = {162},
        number = {3},
        pages = {648-661},
        PMID = {26232230}
    }
    `,
    pub_link: 'https://www.cell.com/cell/fulltext/S0092-8674(15)00824-7'
};


const mtNeuroBenchmark = {
    "name": "MTNeuro Benchmark",
    "link": "/tools/mtneuro-benchmark",
    "blurb": "A benchmark for evaluating representations of brain structure across multiple levels of abstraction.",
    "attribution_logos": [aplLogo, gtLogo],
    "description": [
        "Follow the instructions provided here at our [GitHub Repository](https://github.com/MTNeuro/MTNeuro). For more details, visit the official [website](https://mtneuro.github.io/) .",
        '<img src="' + prasadUrl + '" alt="prasad">',
        "**Description**",
        "MTNeuro introduces a new dataset, annotations, and multiple downstream tasks built on volumetric, micrometer-resolution X-ray microtomography imaging of a large thalamocortical section of mouse brain.",
        "The dataset reveals dense reconstructions of microstructures like cell bodies, vasculature, and axons.",
        "The benchmark evaluates various supervised and self-supervised models for brain-region prediction and pixel-level semantic segmentation.",
        '<img src="' + MTNeuroUrl + '" alt="MTNeuro">',
        "**Key Features:**",
        "- Three Dimensional Multi-Scale Annotated Dataset spanning multiple brain areas.",
        "- Multi-Level Benchmark Tasks featuring both microscopic and macroscopic classification objectives.",
        "- Evaluation of Model Baselines considering both 2D and 3D training regimes.",
        "The data are derived from a unique 3D X-ray microtomography dataset covering areas of mouse cortex and thalamus.",
        "Training scripts and configuration files are provided for executing training and evaluation for baseline networks.",
    ],
    "cite": `
    @inproceedings{quesada_2022_mtneuro,
        title = {MTNeuro: A Benchmark for Evaluating Representations of Brain Structure Across Multiple Levels of Abstraction},
        author = {Quesada, J. and Sathidevi, L. and Liu, R. and Ahad, N. and Jackson, J.M. and Azabou, M. and ... and Dyer, E. L.},
        booktitle = {Thirty-sixth Conference on Neural Information Processing Systems Datasets and Benchmarks Track},
        year = {2022}
    }
    `,
    pub_link: 'https://openreview.net/pdf?id=5xuowSQ17vy'
};


const neuroDataReHack2023 = {
    "name": "NeuroData ReHack 2023",
    "link": "https://github.com/aplbrain/neurodatarehack2023",
    "blurb": "Tool to create visualizations of co-registered cells in the MICrONS datasets using CAVE, BossDB, and NWB."
};

const neuroWorkflowsDemo = {
    "name": "NeuroWorkflows Demo",
    "link": "https://github.com/aplbrain/neuroworkflows-demo",
    "blurb": "INCF Assembly 2023 Demonstration of scalable workflows using Datajoint, NextFlow and BossDB"
};


const categories = {
    "Data Access": [
        intern,
        bossphorus,
        npyjs,
        prDownload,
        neuroglancerUrlShortener,
        motifstudio
    ],

    "Data Processing": [
        // dotmotif,
        mesh_deco,
        saber,
        reconstruct2stack,
        neuvue,
        queries,
        neuroWorkflowsDemo
    ],

    "Network Science": [
        dotmotif,
        grand,
        grandiso,
        neuprint
    ],

    "Visualization": [
        substrate,
        pytri,
        colocar,
    ],

    "Challenges and Hackathons": [
        kasthuriChallenge, 
        mtNeuroBenchmark,
        neuroDataReHack2023    
    ]
}

const featured = [
    intern,
    neuvue,
    neuprint,
    motifstudio,
    queries,
    neuroglancerUrlShortener
];


let tools = Object.values(categories).reduce((a, b) => ([...Object.values(a), ...Object.values(b)]), []);

let all_tools = {};
tools.forEach((t) => {
    all_tools[t.name.toLowerCase()] = t
});

let featured_tools = featured.map(t => {
    return {
        name: t.name,
        link: t.link
    }
});

export default { all_tools, categories, featured_tools };
